
// import {$,jQuery} from 'jquery'; 
// // export for others scripts to use
// window.$ = $;
// window.jQuery = jQuery; 
import 'core-js';
import 'regenerator-runtime/runtime'; 
import '@popperjs/core'
import 'bootstrap'; 

import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';

import '../sections/product.js';
import '../templates/collection.type.js';
import '../templates/gift_card.js';
import '../templates/index';
import '../templates/product';
import '../templates/customers/addresses';
import '../templates/customers/login'; 







// import '../../styles/theme.scss';
// import '../../styles/theme.scss.liquid';
 


import {focusHash, bindInPageLinks} from '@shopify/theme-a11y';
// import {cookiesEnabled} from '@shopify/theme-cart';



// Common a11y fixes
focusHash();
bindInPageLinks(); 

// Apply a specific class to the html element for browser support of cookies.

function cookiesEnabled() {
  return navigator.cookiesEnabled;
}

if (cookiesEnabled()) {
  document.documentElement.className = document.documentElement.className.replace(
    'supports-no-cookies',
    'supports-cookies'
  );
} 

$(document).ready(function(){
    // console.log("New JS!!!");
    
    var $prodCarousel = $('.product-img-carousel').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.product-img-carousel-nav',
      adaptiveHeight:true
    });
    $('.slick-slide').click(function() {
      $prodCarousel.slick('slickNext');
    });
    $('.product-img-carousel-nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.product-img-carousel',
      dots: true,
      centerMode: false,
      focusOnSelect: true
    });
    $('.quantity-selector__more-button').on('click', function(){
      var variantId = $(this).attr("data-variant-id");
      var buttonId = "#add-button-"+variantId;
      var quantityLabel = "#quantity-label-"+variantId;
      // console.log("id is: "+variantId)
      // console.log("button id is: "+buttonId)
      var currentQuantity = $(buttonId).attr("data-cart-quantity");
      // console.log("quantity is:"+currentQuantity);
      currentQuantity++;
      $(buttonId).attr("data-cart-quantity", currentQuantity);
      $(quantityLabel).html(currentQuantity);
    });
    $('.quantity-selector__less-button').on('click', function(){
      var variantId = $(this).attr("data-variant-id");
      var buttonId = "#add-button-"+variantId;
      var quantityLabel = "#quantity-label-"+variantId;
      // console.log("id is: "+variantId)
      // console.log("button id is: "+buttonId)
      var currentQuantity = $(buttonId).attr("data-cart-quantity");
      // console.log("quantity is:"+currentQuantity);
      if (currentQuantity > 1) {
        currentQuantity--;
        $(buttonId).attr("data-cart-quantity", currentQuantity);
        $(quantityLabel).html(currentQuantity);
      }
    });
    $('.quantity-selector-compact__more-button').on('click', function(){
      var variantId = $(this).attr("data-variant-id");
      var buttonId = "#add-button-"+variantId;
      var quantityLabel = "#quantity-label-"+variantId;
      console.log("id is: "+variantId)
      // console.log("button id is: "+buttonId)
      var currentQuantity = $(buttonId).attr("data-cart-quantity");
      // console.log("quantity is:"+currentQuantity);
      currentQuantity++;
      $(buttonId).attr("data-cart-quantity", currentQuantity);
      $(quantityLabel).html(currentQuantity);
    });
    $('.quantity-selector-compact__less-button').on('click', function(){
      var variantId = $(this).attr("data-variant-id");
      var buttonId = "#add-button-"+variantId;
      var quantityLabel = "#quantity-label-"+variantId;
      // console.log("id is: "+variantId)
      // console.log("button id is: "+buttonId)
      var currentQuantity = $(buttonId).attr("data-cart-quantity");
      // console.log("quantity is:"+currentQuantity);
      if (currentQuantity > 1) {
        currentQuantity--;
        $(buttonId).attr("data-cart-quantity", currentQuantity);
        $(quantityLabel).html(currentQuantity);
      }
    });

    $('#shopify-section-product-recommendations').on('click', '.quantity-selector-compact__more-button', function(){
      var variantId = $(this).attr("data-variant-id");
      var buttonId = "#add-button-"+variantId;
      var quantityLabel = "#quantity-label-"+variantId;
      console.log("id is: "+variantId)
      // console.log("button id is: "+buttonId)
      var currentQuantity = $(buttonId).attr("data-cart-quantity");
      // console.log("quantity is:"+currentQuantity);
      currentQuantity++;
      $(buttonId).attr("data-cart-quantity", currentQuantity);
      $(quantityLabel).html(currentQuantity);
    });
    $('#shopify-section-product-recommendations').on('click', '.quantity-selector-compact__less-button', function(){
      var variantId = $(this).attr("data-variant-id");
      var buttonId = "#add-button-"+variantId;
      var quantityLabel = "#quantity-label-"+variantId;
      // console.log("id is: "+variantId)
      // console.log("button id is: "+buttonId)
      var currentQuantity = $(buttonId).attr("data-cart-quantity");
      // console.log("quantity is:"+currentQuantity);
      if (currentQuantity > 1) {
        currentQuantity--;
        $(buttonId).attr("data-cart-quantity", currentQuantity);
        $(quantityLabel).html(currentQuantity);
      }
    });



    
    $('#includedItemListToggle').on('click', function () {
      $('#includedItemsList').toggleClass("ala-carte-list--expanded");
    });
    $('#showAlaCarteBtn').on('click', function () {
      $('.js-read-only-list').hide();
      $('.js-buyable-list').show();
    });
  });

  $(document).on('cart.requestComplete', function(event, cart) {

    $('#cartCount').html(cart.item_count);
    // console.log("event: "+event);
    // console.log("id"+cart);
    // console.log(cart); 
    // console.log("window.item is "+window.itemAdded);
});

// Create event handler for successful addition.
$(document).ajaxSuccess(function(event, jqxhr, settings) {
  // console.log(settings);
  if(settings.url == "/cart/add.js") {
    // console.log("woo! added "+window.itemAdded);
    var buttonId = "#add-button-"+window.itemAdded;
    var itemId = window.itemAdded;
    var initialText = $(buttonId).html();
    // console.log("init text"+initialText);
    $(buttonId).html("<span>Added!</span>");
    $(buttonId).delay(1500).queue(function(n) { 
      var currentInv = 1;
      var quantityLabel = "";
      if ($(this).hasClass("js-in-cart")) {
        $(this).html(initialText);
        $(buttonId).attr("data-cart-quantity", currentInv);
        quantityLabel = "#quantity-label-"+itemId;
        $(quantityLabel).html(currentInv); 
        n();
      }
      else if ($(this).hasClass("quantity-selector__add-button")) {
        $(this).html(initialText); 
        $(buttonId).attr("data-cart-quantity", currentInv);
        quantityLabel = "#quantity-label-"+itemId;
        $(quantityLabel).html(currentInv);
        n();
        $(buttonId).addClass("js-in-cart");
      }
      else {
        // $(this).html(initialText + " more"); n();
        $(this).html(initialText); 
        $(buttonId).attr("data-cart-quantity", currentInv);
        quantityLabel = "#quantity-label-"+itemId;
        $(quantityLabel).html(currentInv);
        n();
        $(buttonId).addClass("js-in-cart");
      }
    });

    jQuery.getJSON('/cart.js', function(cart) {
      // now have access to Shopify cart object
      $('#cartCount').html(cart.item_count);
    
   } );
    
    $('.nav-cart').addClass("apply-shake");
    $('.nav-cart').delay(1500).queue(function(n) { 
      $('.nav-cart').removeClass("apply-shake"); n();
    });
  }
});

// Create event handler for failed addition.
// $(document).ajaxError(function(event, jqxhr, settings, thrownError) {
//   if(settings.url == "/cart/add.js") {

//   }
// });

var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false;

jQuery(document).ready(function($){
    if(!isMobile) {
      $('.dropdown > a').click(function(){
          location.href = this.href;
      });
    }
});
//Allow clicks on navbar parent links 
// jQuery(function($) {
//   $('.dropdown > a').click(function(){
//       location.href = this.href;
//   });
// }); 


$(document).ready(function(){
  $('[data-toggle="collapse"]').click(function() {
    $('#mainNav').toggleClass("expanded");
  });
  $('.notification__close-link').on("click", function(){
    $('#notificationPanel').dequeue();
  })

});

// $('.collapse').collapse();

// $(document).ready(function() {
//   $(".navbar-toggler").click(function(){
//     $(".collapse").collapse('toggle');
//   });
//   $('.collapse').on('shown.bs.collapse', function () {
//     alert("yay!");
//   });
// });

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}